<template>
    <div id="floating-button-container">
        <div
            :class="{
                'relative-container': true,
                'is-active': isActive,
            }"
            @click="toggleButton"
        >
            <div class="top" v-if="options.top && options.top.length">
                <b-tooltip
                    v-for="(option, i) in options.top"
                    :placement="option.tooltip ? option.tooltip.side : ''"
                    :key="'top-' + i"
                    :target="'secondary-button-top-' + i"
                    :title="option.tooltip ? option.tooltip.title : ''"
                >
                </b-tooltip>
                <button
                    v-for="(option, i) in options.top"
                    :key="i"
                    :id="'secondary-button-top-' + i"
                    class="secondary-button"
                    :style="`top: calc(-40px * ${isActive ? i : 0});`"
                    @click="() => emitOption(option.emit)"
                >
                    <icon :name="option.icon.name" :scale="option.icon.scale" color="var(--light)" />
                </button>
            </div>
            <div class="left" v-if="options.left && options.left.length">
                <b-tooltip
                    v-for="(option, i) in options.left"
                    :placement="option.tooltip ? option.tooltip.side : ''"
                    :key="'left-' + i"
                    :target="'secondary-button-left-' + i"
                    :title="option.tooltip ? option.tooltip.title : ''"
                >
                </b-tooltip>
                <button
                    v-for="(option, i) in options.left"
                    :key="i"
                    :id="'secondary-button-left-' + i"
                    class="secondary-button"
                    :style="`left: calc(-40px * ${isActive ? i : 0});`"
                    @click="() => emitOption(option.emit)"
                >
                    <icon :name="option.icon.name" :scale="option.icon.scale" color="var(--light)" />
                </button>
            </div>
            <div class="right" v-if="options.right && options.right.length">
                <b-tooltip
                    v-for="(option, i) in options.right"
                    :placement="option.tooltip ? option.tooltip.side : ''"
                    :key="'right-' + i"
                    :target="'secondary-button-right-' + i"
                    :title="option.tooltip ? option.tooltip.title : ''"
                >
                </b-tooltip>
                <button
                    v-for="(option, i) in options.right"
                    :key="i"
                    :id="'secondary-button-right-' + i"
                    class="secondary-button"
                    :style="`right: calc(-40px * ${isActive ? i : 0});`"
                    @click="() => emitOption(option.emit)"
                >
                    <icon :name="option.icon.name" :scale="option.icon.scale" color="var(--light)" />
                </button>
            </div>
            <div class="bottom" v-if="options.bottom && options.bottom.length">
                <b-tooltip
                    v-for="(option, i) in options.bottom"
                    :placement="option.tooltip ? option.tooltip.side : ''"
                    :key="'bottom-' + i"
                    :target="'secondary-button-bottom-' + i"
                    :title="option.tooltip ? option.tooltip.title : ''"
                >
                </b-tooltip>
                <button
                    v-for="(option, i) in options.bottom"
                    :key="i"
                    :id="'secondary-button-bottom-' + i"
                    class="secondary-button"
                    :style="`bottom: calc(-40px * ${isActive ? i : 0});`"
                    @click="() => emitOption(option.emit)"
                >
                    <icon :name="option.icon.name" :scale="option.icon.scale" color="var(--light)" />
                </button>
            </div>

            <button class="main-button">
                <icon name="times" scale="1" color="white" />
            </button>
        </div>
    </div>
</template>
<script>
// =================
// Icons
// =================

import 'vue-awesome/icons/times'

/**
 *
 * @param {Object} options - { left/right/top/bottom: [{ title, icon: {name, scale}, emit: {name, data}] }
 */
export default {
    name: 'NewRightFloatingButton',
    props: {
        options: Object,
    },
    data() {
        return {
            isActive: false,
        }
    },
    methods: {
        toggleButton() {
            this.isActive = !this.isActive
        },
        emitOption({ name, data }) {
            this.$emit(name, data)
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/scss/components/Utils/new-right-floating-button.scss';
</style>
